import React from 'react';

interface ReportItemProps {
    label: string;
    handler: () => void;
}

export const ReportItem: React.FC<ReportItemProps> = ({ label, handler }) => {
    return (
        <li className='nav-item text-dark' onClick={handler}>
            <a className='nav-link text-dark' href='#'>
                {label}
            </a>
        </li>
    );
};
